// Single source of truth for the Vivo companies-portal shell nav + routes.
// Plain CommonJS data (no Vue / .vue imports) so it is consumed by
// router/index.ts, layouts/new/DashboardLayout.vue AND the node:test unit test
// without any build step. Verbatim order from the mockup (companies-dashboard.html).

/**
 * The 10 sidebar sections. `icon` = Material Icons ligature (vue-material).
 * The old standalone "refunds" screen was removed (S7): refunds are now merged
 * into claims — there is no separate refunds route, view, mock, or backend.
 * `departments` and `admin-followup` are real, backend-complete C7/C8 screens
 * that previously had no nav entry anywhere in the app (gap-analysis fix) —
 * added here, right after employees, since both are employee-management
 * sub-workflows an HR user reaches for from the same mental context.
 * S10/M12 (Vivo ببساطة Oct-4) promoted two more backend-complete screens to
 * top-level nav, after policyContract: `providers` (مقدّمو الخدمة — the service
 * provider / network directory, route /providers) and `chatbot-qa` (أسئلة الشركة
 * — Company Q&A, route /company/chatbot-qa; previously only linked from within
 * company.vue). `companyData` is pinned to `exact` so that visiting the nested
 * /company/chatbot-qa lights ONLY the Company Q&A entry, not Company Data too
 * (vue-router's default inclusive router-link-active would match both).
 */
const VIVO_NAV = [
  { name: 'home', path: '/home', icon: 'dashboard', labelKey: 'nav.home' },
  { name: 'employees', path: '/employees', icon: 'people', labelKey: 'nav.employees' },
  { name: 'departments', path: '/departments', icon: 'apartment', labelKey: 'nav.departments' },
  { name: 'admin-followup', path: '/admin-followup', icon: 'assignment_ind', labelKey: 'nav.adminFollowup' },
  { name: 'claims', path: '/claims', icon: 'assignment', labelKey: 'nav.claims' },
  { name: 'policyContract', path: '/policy-contract', icon: 'description', labelKey: 'nav.policyContract' },
  { name: 'providers', path: '/providers', icon: 'local_hospital', labelKey: 'nav.providers' },
  { name: 'chatbot-qa', path: '/company/chatbot-qa', icon: 'chat', labelKey: 'nav.chatbotQa' },
  { name: 'reports', path: '/reports', icon: 'bar_chart', labelKey: 'nav.reports' },
  { name: 'companyData', path: '/company', icon: 'settings', labelKey: 'nav.companyData', exact: true },
];

// C2–C15 screens (C1 login is a standalone top-level route). All are
// placeholders in Phase 2 — Phase 5 builds the real pages. `titleKey` feeds the
// placeholder heading + breadcrumb.
const VIVO_ROUTES = [
  { name: 'home', path: '/home', titleKey: 'nav.home' },
  { name: 'employees', path: '/employees', titleKey: 'nav.employees' },
  { name: 'employees-add', path: '/employees/add', titleKey: 'screens.employeeAdd' },
  { name: 'employees-import', path: '/employees/import', titleKey: 'screens.employeeImport' },
  { name: 'employee-page', path: '/employees/:id', titleKey: 'screens.employeePage' },
  { name: 'departments', path: '/departments', titleKey: 'screens.departments' },
  // C1/E1 (HR issues 2026-10-16): add/edit moved OUT of the list screens onto
  // their own pages. Declared here only — deliberately NOT in VIVO_NAV, since a
  // sub-page is reached from its list, not from the sidebar (and router-link's
  // inclusive matching keeps the parent entry lit on /departments/new).
  { name: 'departments-new', path: '/departments/new', titleKey: 'screens.departmentAdd' },
  { name: 'departments-edit', path: '/departments/:id/edit', titleKey: 'screens.departmentEdit' },
  { name: 'admin-followup', path: '/admin-followup', titleKey: 'screens.adminFollowup' },
  { name: 'claims', path: '/claims', titleKey: 'nav.claims' },
  { name: 'claims-new', path: '/claims/new', titleKey: 'screens.claimAdd' },
  { name: 'policy-contract', path: '/policy-contract', titleKey: 'nav.policyContract' },
  { name: 'providers', path: '/providers', titleKey: 'screens.providers' },
  { name: 'reports', path: '/reports', titleKey: 'nav.reports' },
  { name: 'company', path: '/company', titleKey: 'nav.companyData' },
  { name: 'chatbot-qa', path: '/company/chatbot-qa', titleKey: 'screens.chatbotQa' },
];

module.exports = { VIVO_NAV, VIVO_ROUTES };
